import { Injectable } from '@angular/core';

import { Observable, BehaviorSubject } from 'rxjs';
import { map, tap, filter } from 'rxjs/operators';

@Injectable()
export class AuthService {
    _userSbj: BehaviorSubject<any> = new BehaviorSubject(null); 
    user$: Observable<any> = this._userSbj.asObservable();
    set user(user: any) {
        this._userSbj.next(user);
    }
    get user() {
        return this._userSbj.getValue();
    }

    constructor(
    ) {
    }

}
